<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <calculateOfferPosition></calculateOfferPosition>
    </v-dialog>
</template>

<script>
    import calculateOfferPosition from './CalculateOfferPosition.vue'

    // Settings Types
    import {
        OfferPosition
    } from '../../../store/namespace-helper'

    export default {
      name: 'CalculateOfferPositionDialog',
      components: {
        calculateOfferPosition
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[OfferPosition.getters.getOpenCalculateDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Offers/OfferPositions/CalculateOfferPositionDialog.vue